var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$mq === _vm.$enums.mqBreakpoints.MOBILE)?_c('user-account-purchases-mobile-menu'):_c('user-account-purchases-tabs')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }